import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function minimaleEisenPerDossierReducer(state = initialState.minimaleEisenPerDossier, action) {
	switch (action.type) {
		case types.MINIMALE_EISEN_PER_DOSSIER_LOADED: {
			return Object.assign({},
				state,
				{
					id: action.body.item ? action.body.item.dossierId : null,
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		case types.MINIMALE_EISEN_PER_DOSSIER_SAVED: {
			return Object.assign({},
				state,
				{
					id: action.body.item.dossierId,
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		default:
			return state;
	}
}
